import { Card, CardVariants, Icon, IconName, Stack } from '@optimus-web/core';
import { SecurityCardSkeleton } from './SecurityCardSkeleton';

interface SecurityCardProps {
    variant?: CardVariants;
    action: React.ReactNode;
    icon: IconName;
    isLoading?: boolean;
    'data-test-id'?: string;
}

export const SecurityCard = ({
    children,
    action,
    icon,
    isLoading,
    ...other
}: React.PropsWithChildren<SecurityCardProps>) => {
    if (isLoading) {
        return <SecurityCardSkeleton />;
    }

    return (
        <Card padding="300" {...other}>
            <Stack spacing="100" phoneOnly={{ vertical: true }}>
                <Icon value={icon} />
                <Stack
                    spacing="200"
                    distribution="space-between"
                    fill
                    largePhoneMax={{ vertical: true, spacing: '200' }}
                >
                    <Stack vertical spacing="100">
                        {children}
                    </Stack>
                    {action}
                </Stack>
            </Stack>
        </Card>
    );
};
